function epicAccountSlideshow () {
  Shopify.theme.jsEpicAccountSlideshow = {
    init: function init() {
      const sliders = document.querySelectorAll('.account-slider');
      sliders.forEach(slider => this.customizeSlider(slider));
    },
    initSlider: function initSlider(sliderElement) {
      const autoplayInterval = sliderElement.getAttribute('data-autoplay-interval');
      const options = {
        cellAlign: 'left',
        adaptiveHeight: false,
        prevNextButtons: false,
        pageDots: true,
        contain: true,
        autoPlay: autoplayInterval ? autoplayInterval * 1000 : false
      };
      return new window.Flickity(sliderElement, options);
    },
    customizeSlider: function customizeSlider(sliderElement) {
      const flkty = this.initSlider(sliderElement);
      const section = sliderElement.closest('.account-slider-wrapper');
      if (!section) return;
      this.setMaxHeight(section, flkty);
      window.addEventListener('resize', () => this.setMaxHeight(section, flkty));
    },
    setMaxHeight: function setMaxHeight(section, flkty) {
      const cells = section.querySelectorAll('.account-slider-slide');
      let maxHeight = 0; // Reset heights

      cells.forEach(cell => cell.style.height = 'auto'); // Calculate max height

      maxHeight = Math.max(...Array.from(cells, cell => cell.offsetHeight)); // Apply max height to all cells

      cells.forEach(cell => cell.style.height = `${maxHeight}px`);
      flkty.resize();
    }
  };
  Shopify.theme.jsEpicAccountSlideshow.init();
}

export { epicAccountSlideshow as default };
